import { ActiveChannelTypeEnum } from 'constants-channel';

export default function isBuildingChannel(channel: any) {
  return (
    channel.type === ActiveChannelTypeEnum.Property &&
    !channel.isSub &&
    channel.parent
  );
}
